import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles, userRole, redirectTo }) => {
  if (userRole === undefined || userRole === null) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;
